// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__28EPY","footer":"ChangeClinic_footer__3WMri"};